const CONTACT_FORM = "/contact-form";

export default {
  CONTACT_FORM,
};
